import { useNavigate, useSearchParams } from 'react-router-dom';
import { AddBindingUserPage } from '@practium/features/users';
import type {
	BindingTab,
	BindingFarmerFormData,
	BindingConsultantFormData,
	BindingUserApiResponse,
} from '@practium/features/users';
import { useGetBindingUserById } from '@practium/features/api';
import { usePermissions } from '@practium/features/permissions';

const BINDING_TYPE = {
	farmers: 1,
	consultants: 2,
} as const satisfies Record<BindingTab, number>;

export const ViewUserPageClient = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { abilities } = usePermissions();
	const type = (searchParams.get('type') as BindingTab) || 'farmers';
	const id = searchParams.get('id') || '';
	const subject = type === 'farmers' ? 'farmers' : 'consultants';
	const canEdit = abilities.can('update', subject);
	const canDelete = abilities.can('delete', subject);

	const { data: bindingUser } = useGetBindingUserById<BindingUserApiResponse>({
		bindingType: BINDING_TYPE[type],
		bindingUserId: id,
	});

	if (!bindingUser) return null;

	const initialData: BindingFarmerFormData | BindingConsultantFormData =
		type === 'farmers'
			? {
				name: bindingUser.name,
				surName: bindingUser.surName,
				phoneNumber: bindingUser.phoneNumber ?? '',
				email: bindingUser.email,
				document: bindingUser.document ?? '',
				status: bindingUser.status ? 'true' : 'false',
			}
			: {
				name: bindingUser.name,
				surName: bindingUser.surName,
				phoneNumber: bindingUser.phoneNumber ?? '',
				email: bindingUser.email,
				document: bindingUser.document ?? '',
				status: bindingUser.status ? 'true' : 'false',
			};

	const bindingType = type === 'farmers' ? 1 : 2;

	const handleEnterProfile = () => {
		window.open(`/dashboard?forBinding=${id}&bindingType=${bindingType}`, '_blank');
	};

	return (
		<AddBindingUserPage
			type={type}
			onBack={() => navigate('/usuarios')}
			initialMode="view"
			initialData={initialData}
			onDelete={canDelete ? () => navigate('/usuarios') : undefined}
			canEdit={canEdit}
			bindingUserId={id}
			avatarUrl={bindingUser.avatar?.url ?? bindingUser.profileImage ?? undefined}
			onEnterProfile={handleEnterProfile}
		/>
	);
};
